import React from "react";

import WishList from "../components/WishList";
import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";
import "./styles/Wish.css";

import { connect } from "react-redux";
import * as actions_wish from "../redux/actions/wishActions";
import { Translate } from "react-redux-i18n";

class Wish extends React.Component {
  componentDidMount() {
    this.fetchWishList();
  }

  fetchWishList = async () => {
    try {
      await this.props.LoadWish(this.props.token, { id: this.props.user_id });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const count = this.props.wishList?.length || 0;

    return (
      <PanelLayout>
        <div className="wish-page">
          <header className="wish-page__header">
            <h1 className="wish-page__title">
              <Translate value="wish_title" />
            </h1>
            {!this.props.loading && count > 0 && (
              <p className="wish-page__subtitle">
                {count} <Translate value="ads" />
              </p>
            )}
          </header>

          {this.props.loading ? <ListSkeleton /> : <WishList />}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    wishList: reducer.wish.list,
    error: reducer.wish.error,
    loading: reducer.wish.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadWish: (token, params) => dispatch(actions_wish.loadList({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wish);
